"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MenuTitle_1 = __importDefault(require("./MenuTitle"));
var headerContent_1 = __importDefault(require("./headerContent"));
require("./style.sass");
var HeaderBar = function (props) {
    var onSave = props.onSave, title = props.title, hideSave = props.hideSave, extraComponent = props.extraComponent;
    return (react_1.default.createElement("div", { className: "header-container" },
        react_1.default.createElement(headerContent_1.default, null),
        props.title && (react_1.default.createElement(MenuTitle_1.default, { addMore: props.addMore, alias: props.alias, list: props.list, onAddClick: props.onAddClick, onChangeTab: props.onChangeTab, onSave: onSave, path: props.path, title: title, hideSave: hideSave, extraComponent: extraComponent })),
        react_1.default.createElement("div", { className: "headerbar-card" },
            react_1.default.createElement("div", { className: "container" }, props.children))));
};
exports.default = HeaderBar;
